class MergeDataCommon {
    static formatNumber(data = "", fixedNum = 4, nullLabel = null) {
        const result = Number.parseFloat(data)
            .toFixed(fixedNum)
            .replace(/^-([.0]*)$/, "$1");
        return isNaN(result) ? nullLabel : result;
    }

    static formatString(data, defaultValue = "-") {
        return data ? data : defaultValue;
    }
    static formatToLocaleString(data, fractionNum = 2) {
        if (isNaN(data)) {
            return null;
        }
        return Number.parseFloat(data).toLocaleString("zh-CN", {
            minimumFractionDigits: fractionNum,
            maximumFractionDigits: fractionNum,
        });
    }

    /**
     *
     * @param {String} datetime
     * @returns {String} YYYY-MM-DD
     */
    static DateFormatToLocaleString(datetime) {
        datetime = datetime ? datetime : new Date().getTime();
        datetime = new Date(datetime);
        let year = datetime.getFullYear();
        let month = datetime.getMonth() + 1;
        let day = datetime.getDate();

        if (month < 10) {
            month = "0" + month;
        }
        if (day < 10) {
            day = "0" + day;
        }
        return `${year}-${month}-${day}`;
    }

    static formatFundData(data = "", fixedNum = 2, isSigned = true, unit = "%") {
        data = Number.parseFloat(data)
            .toFixed(fixedNum)
            .replace(/^-([.0]*)$/, "$1");
        let color = "";
        if (isNaN(data)) {
            data = "";
            unit = "";
        } else {
            if (isSigned) {
                data > 0 ? (data = "+" + data) : data;
            }
            if (data != 0) {
                color = data > 0 ? "text-primary-red" : "text-green";
            }
        }
        return { data: data + unit, color: color };
    }
}

export default MergeDataCommon;
